import * as React from "react";
import Modal from "react-modal";
import CheckmarkIcon from "assets/Icons/Checkmark.svg";

const style = require("./banner.css");

interface Props {
  isBannerDisplayed: boolean;
  closeBanner: () => void;
  message: string;
}

/* NOTE: Banner flashes with css animation and unmounts on clickAway of modal */
export const Banner: React.FunctionComponent<Props> = ({
  isBannerDisplayed, closeBanner, message,
}) => (
  <Modal
    contentLabel="Banner"
    overlayClassName={style.modalOverlay}
    isOpen={isBannerDisplayed}
    onRequestClose={closeBanner}
    className={style.modalBase}
  >
    <div className={style.banner}>
      <CheckmarkIcon className={style.icon} />
      <h6 className={style.heading}>{message}</h6>
    </div>
  </Modal>
);
